module.exports = "/virtual-football/img/video/clubs/spain/atletico-madrid.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/spain/atletico-madrid.png
// module id = 305
// module chunks = 6